import React, { useState } from "react";
import { CalendarDays, Moon, Sun } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { SERIF } from "./practiceApi";

export const TOUR_KEY = "soulumo_plan_tour_seen";

const STEPS = [
  { icon: Sun, title: "Listen during your day", body: "Choose Light, Moderate or Deep: one, two or three short listens to your installation each day." },
  { icon: Moon, title: "Rest with it at night", body: "Add the optional 3-hour Night Installation, so your words can stay with you while you sleep." },
  { icon: CalendarDays, title: "Simply Day 1 of 21", body: "A quiet tracker shows where you are. No streaks, nothing to fail. A missed day just waits for you." },
];

// Shown once, the first time a member taps "Create My 21-Day Plan".
export const PlanTour = ({ open, onDone }) => {
  const [i, setI] = useState(0);
  const s = STEPS[i];
  const Icon = s.icon;
  const last = i === STEPS.length - 1;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onDone(false)}>
      <DialogContent className="max-w-sm border-[#2b3d5e] bg-[#0b1a33] p-7 text-[#f3ecd9]" data-testid="plan-tour">
        <p className="text-[0.62rem] uppercase tracking-[0.28em] text-[#d7bb7a]" data-testid="plan-tour-step">Step {i + 1} of 3</p>
        <div key={i} className="animate-in fade-in slide-in-from-right-2 duration-300">
          <Icon size={26} className="mt-5 text-[#d7bb7a]" />
          <DialogTitle className="mt-3 text-2xl font-normal text-[#f3ecd9]" style={{ fontFamily: SERIF }}>{s.title}</DialogTitle>
          <p className="mt-2 text-sm leading-relaxed text-[#cfc6ae]">{s.body}</p>
        </div>
        <div className="mt-6 flex items-center justify-between">
          <div className="flex gap-1.5">{STEPS.map((_, k) => <span key={k} className={`h-1.5 w-5 rounded-full ${k <= i ? "bg-[#d7bb7a]" : "bg-[#1e2f4f]"}`} />)}</div>
          <button type="button" onClick={() => (last ? onDone(true) : setI(i + 1))} data-testid="plan-tour-next-btn"
            className="rounded-full bg-[#d7bb7a] px-5 py-2.5 text-xs uppercase tracking-[0.22em] text-[#0b1a33] transition-opacity hover:opacity-90">
            {last ? "Create my plan" : "Next"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
